"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = Loading;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function Loading(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    stroke: "#DBE1DD"
  }), (0, _core.jsx)("mask", {
    id: "Medium_svg__a",
    fill: "#fff"
  }, (0, _core.jsx)("path", {
    d: "M10.648 2.092a10 10 0 0110.594 6.09l-.913.377a9.012 9.012 0 00-9.548-5.488l-.133-.98z"
  })), (0, _core.jsx)("path", {
    d: "M10.648 2.092a10 10 0 0110.594 6.09l-.913.377a9.012 9.012 0 00-9.548-5.488l-.133-.98z",
    stroke: "#1F2D27",
    strokeWidth: 2,
    mask: "url(#Medium_svg__a)"
  }));
}

Loading.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Loading"
};